<template>
  <component
    :is="tag"
    class="s-app-container"
    :class="`s-app-container--size-${size}`"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
/**
 * Centered container with max-width and responsive padding.
 * Provides consistent page layout wrapper across applications.
 */

withDefaults(
  defineProps<{
    size?: "lg" | "md" | "sm";
    tag?: "div" | "section";
  }>(),
  { tag: "div", size: "lg" },
);
</script>

<style lang="postcss">
.s-app-container {
  @apply mx-auto max-w-full px-3;

  &--size-sm {
    @apply w-3xl;
  }

  &--size-md {
    @apply w-screen-900;
  }

  &--size-lg {
    @apply w-screen-1200;
  }

  @screen 400 {
    @apply px-6;
  }
}
</style>
